import React, { useEffect } from 'react';
import PartnerMainContainer from '../../../components/PartnerMainContainer';
import TitlePartner from '../component/Title';
import PartnerPageService from '../../../services/PartnerPageService';

const Configuration = () => {
    useEffect(() => {
        PartnerPageService.loadConfiguration();
    }, []);

    return (
        <PartnerMainContainer>
            <TitlePartner title="Configuration" sub="" icon="⚙️" />
        </PartnerMainContainer>
    );

}

export default Configuration;
